import RecentlyViewedProducts from './recently-viewed-products-controller'

export default RecentlyViewedProducts
